/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspage_Empty1Inputs */

const vi_cmspage_empty1 = /** @type {(inputs: Cmspage_Empty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có trang nào khớp bộ lọc.`)
};

/**

* @param {Cmspage_Empty1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspage_empty1 = /** @type {((inputs?: Cmspage_Empty1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspage_Empty1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspage_empty1(inputs)
});
export { cmspage_empty1 as "cmsPage_empty" }